/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap"
import BaseCom from "./BaseCom"
import { qreq } from "../shared/qrequest";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Icon from "./Icon";
import AboutModal from "./Admin/AboutModal";
import { getCurrentLangItem } from "../shared/GLang";
import L from "./Lang";

class HelpModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            showAboutModal: false,
            lang: getCurrentLangItem() ?? { ident: 'en' },
            paid: false,
            org: {}
        };
    }

    async componentDidMount() {
        await this.pullLang();
        await this.pullOrg();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.siteDomainID !== this.props.siteDomainID)
            await this.pullOrg();
        if (getCurrentLangItem() !== prevState.lang) {
            this.setState({ lang: getCurrentLangItem() ?? { ident: 'en' } });
        }
    }

    pullLang = async () => {
        try {
            let j = await qreq.getAsync('/api/domain/payment/check');
            if (j.errorCode === 0)
                this.setState({ paid: true });
        }
        catch (e) {
            console.error(e);
        }
        this.setState({ lang: getCurrentLangItem() });
    }

    pullOrg = async () => {
        try {
            let j = await qreq.getAsync('/api/organization/get/current' + (this.props.siteDomainID ? '?siteDomainID=' + this.props.siteDomainID : ''));
            if (j.item)
                this.setState({ org: j.item });
        }
        catch (e) {
            console.error(e);
        }
    }


    goWalkthrough = async () => {
        try {
            let j = await qreq.postAsync('/api/tutorial/reset', {});
            if (j.errorCode === 0)
                window.location.reload();
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    goPDF = () => {
        if (this.state.org.ident === 'banktech') {
            window.open('/pdf/manual-es.pdf', '_blank');
        }
        else {
            window.open('/pdf/manual-en.pdf', '_blank');
        }
    }

    goCalendar = () => {
        /*
        if (this.state.org?.ident === 'taplocal') {
            if (this.state.paid)
                window.open('https://calendly.com/taplocalaccountmanagement/account-management-call', '_blank');
            else
                window.open('https://taplocalnow.com/general-scheduling/', '_blank');
        }
        else if (this.state.org?.ident === 'banktech') {
            if (this.state.lang.ident === 'es')
                window.open('https://calendly.com/taplocalpr-creative-esp/creative-call', '_blank');
            else
                window.open('https://calendly.com/taplocalpr-creative/creative-call', '_blank');
        }
        */
        if (this.state.org?.scheduleURL) {
            let url = this.state.org.scheduleURL;
            if (url.indexOf('?') >= 0)
                url += '&lang=' + (this.state.lang.ident);
            else
                url += '?lang=' + (this.state.lang.ident);
            window.open(url);
        }
        else if (!this.state.org)
            this.alert('No calendar link for unknown organization.');
        else
            this.alert('No calendar link for organization: ' + this.state.org.name);
    }

    goVideoTutorials = () => {
        window.open('https://www.youtube.com/playlist?list=PLZk4UCTiop4dYc1L7OnC6njF0ZZ07ZiH7', '_blank');
    }

    render() {
        return <>
            <AboutModal show={this.state.showAboutModal} onHide={() => this.setState({ showAboutModal: false })} org={this.state.org} />
            <Modal show={this.props.show} onHide={this.props.onHide} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title><L>Help Menu</L></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {this.state.org && <div className="row mb-2">
                        <div className="col-lg-12"><button className="btn btn-mod btn-outline-primary btn-lg d-block mb-2 w-100" onClick={this.goCalendar}>
                            <Icon icon="faCalendar" /> <L>Schedule Pro Web Design</L></button>
                        </div>
                    </div>}

                    <div className="row mb-2">
                        <div className="col-lg-6">
                            <div className="d-grid gap-2">
                                <button className="btn btn-mod btn-outline-secondary btn-lg btn-block mb-2" onClick={this.goWalkthrough}><Icon icon="faChalkboardUser" /> <L>Web Builder Walkthrough</L></button>
                                <button className="btn btn-mod btn-outline-secondary btn-lg btn-block mb-2" onClick={() => this.setState({ showAboutModal: true })}><Icon icon="faInfo" /> <L>About Web Builder</L></button>

                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="d-grid gap-2">
                                <button className="btn btn-mod btn-outline-secondary btn-lg btn-block mb-2" onClick={this.goPDF}><Icon icon="faFilePdf" /> <L>User Manual PDF</L></button>
                                <button className="btn btn-mod btn-outline-secondary btn-lg btn-block mb-2" onClick={this.goVideoTutorials}><Icon icon="faVideo" /> Video Tutorials</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>;
    }
}

export default withParamsAndNavigate(HelpModal);